import React, { useState } from "react";
import { StyleSheet, Image, Text, View } from "react-native";
import { Entypo } from "@expo/vector-icons";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import { useAssets } from "expo-asset";
import { readAsStringAsync } from "expo-file-system";
import image from "../assets/picture2.png";
// import data from "../assets/English.json"
// import English from "./English/English";

const Detail = (props) => {

  const Content = `Given the lack of educational materials focusing on preventing unintentional falls and offering pre-hospital care for school-age children, number of children experiencing falling accidents are unfortunately common. To bridge this gap, this booklet has been developed in different languages by experts involved in the national multicenter study called BOne Setting Associated Disability (BOSAD) study in Ethiopia and Gambia. The aim of this study is to prevent complications arising from musculoskeletal injuries managed with tight bandaging, bamboo splinting and repetitive massaging. The whole aim of this BOSAD researcher team is to improve the wholistic care given for all musculoskeletal injury throughout the country.`;

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => props.navigation.goBack()}>
          <Entypo name="chevron-left" color="#283618" size={25} />
        </TouchableOpacity>
        {/* <Entypo name="chevron-left" color="#FFF" size={25} /> */}
      </View>

      <View style={styles.cont3}>
        <ScrollView
          style={{ flex: 1 }}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
        >
          {/* <English /> */}
        </ScrollView>
      </View>
    </View>
  );
};

export default Detail;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fefae0",
  },
  title: {
    fontSize: 25,
    marginTop: 30,
  },
  subtitle: {
    fontSize: 20,
    color: "#474747",
    marginTop: 10,
  },
  text: {
    fontSize: 18,
    paddingRight: 80,
    lineHeight: 25,
  },
  btn: {
    backgroundColor: "#E2443B",
    paddingHorizontal: 60,
    paddingVertical: 12,
    borderRadius: 30,
  },
  btnText: {
    fontSize: 20,
    color: "#FFF",
  },
  cont1: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginTop: 40,
  },
  c3: {
    height: 20,
    width: 20,
    borderRadius: 5,
    backgroundColor: "#529CC0",
  },
  c2: {
    height: 20,
    width: 20,
    borderRadius: 5,
    backgroundColor: "#529C47",
    marginHorizontal: 10,
  },
  c1: {
    height: 20,
    width: 20,
    borderRadius: 5,
    backgroundColor: "#E2443B",
  },
  selected: {
    borderColor: "#E2443B",
    height: 30,
    width: 30,
    borderRadius: 5,
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  cont2: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    marginVertical: 25,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    paddingHorizontal: 20,
    paddingTop: 50,
  },
  img: {
    height: "45%",
    width: "50%",
  },
  cont3: {
    flex: 1,
    backgroundColor: "#FFF",
    width: "100%",
    borderRadius: 5,
    paddingHorizontal: 20,
  },
});
